module.exports = __webpack_public_path__ + "static/img/automationnew.29e0031b.png";